import { CategoriaCliente } from '../../model/categoria-cliente/categoria-cliente';

/**
 * Puerto Abstracto: CategoriaClienteRepository
 * 
 * Define el contrato para gestión de categorías de cliente.
 * Migrado desde: FilterProgramarServiciosViewImpl.java
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpCategoriaClienteRepository (adaptador) lo implementa en infraestructura
 * 
 * @author Sura - Migración GWT a Spring Boot
 */
export abstract class CategoriaClienteRepository {

  /**
   * Obtiene las categorías de un cliente (aseguradora) para el dropdown.
   * Las categorías se filtran por cliente y opcionalmente por TIPO_ATENCION.
   * 
   * Legacy: FilterProgramarServiciosViewImpl (dropdown Categoría)
   * 
   * @param nmconsecutivoCliente Código del cliente (aseguradora)
   * @returns Lista de categorías disponibles
   */
  abstract obtenerCategoriasCliente(
    nmconsecutivoCliente: number
  ): Promise<CategoriaCliente[]>;
}
